export default "__VITE_ASSET__BDcvAThz__"